import { AuthProductName, ViewName } from '@/types'

const arcadeDecorations = {
  id: 'arcade',
  name: 'Arcade',
  viewDecorations: [
    {
      hideCreate: true,
      badgeText: '',
      viewName: ViewName.Login,
      offerMessage: '',
      title: 'Log in to your account',
      body: 'Enter the email address associated with your account.'
    },
    {
      badgeText: '',
      viewName: ViewName.Success,
      offerMessage: '',
      title: "You're logged in!",
      body: 'Now open Arcade.'
    }
  ],
  authProductName: AuthProductName.WEBSITE
}
export default arcadeDecorations
